import { CommonModule } from "@angular/common";
import { NgModule } from '@angular/core';
import { AccountSharedModule } from 'apps/account/src/account-shared';
import { PermissionsComponent } from "./permissions.component";


@NgModule({
    imports: [
        CommonModule,
        AccountSharedModule
    ],
    declarations: [
        PermissionsComponent
    ],
    exports: [
        PermissionsComponent
    ]
})
export class PermissionsModule {

}
